// 本地化配置
export const LOCAL_CONFIG = window.CONFIG || {};

if (process.env.NODE_ENV === 'development') {
  LOCAL_CONFIG.server = '/api';
}
